/**
 * @generated SignedSource<<dac6e36ff74a516179c949540cf9e555>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type hooksAdvertisementConfigQuery$variables = {
  id?: string | null;
};
export type hooksAdvertisementConfigQuery$data = {
  readonly appConfig: {
    readonly json: unknown | null;
  } | null;
};
export type hooksAdvertisementConfigQuery = {
  response: hooksAdvertisementConfigQuery$data;
  variables: hooksAdvertisementConfigQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "fields": [
      {
        "kind": "Variable",
        "name": "entityId",
        "variableName": "id"
      }
    ],
    "kind": "ObjectValue",
    "name": "filter"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "json",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "hooksAdvertisementConfigQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "AppConfig",
        "kind": "LinkedField",
        "name": "appConfig",
        "plural": false,
        "selections": [
          (v2/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "hooksAdvertisementConfigQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "AppConfig",
        "kind": "LinkedField",
        "name": "appConfig",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "8c9858ea7068700cbaf0b059b4f09601",
    "id": null,
    "metadata": {},
    "name": "hooksAdvertisementConfigQuery",
    "operationKind": "query",
    "text": "query hooksAdvertisementConfigQuery(\n  $id: String\n) {\n  appConfig(filter: {entityId: $id}) {\n    json\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "f63f6f4eb197a85a462b31461482cb84";

export default node;
